<template>
  <div>
    <v-tabs
      v-model="selectedTab"
      color--text="red"
      grow
    >
      <v-tabs-slider color="#e72b37" />
      <!-- Die Navigationsdaten kommen aus den headerItems -->
      <v-tab
        v-for="headerItem in tabHeaders"
        :key="headerItem"
        :disabled="
          !(
            headerItem === 'Zuschlagstypen' ||
            headerItem === 'Zuschlagsrechnertexte' ||
            headerItem === 'Zeittypen' ||
            headerItem === 'Zuschlagstyp Pauschalen'
          )
        "
        style="color: #e72b37"
      >
        {{ headerItem }}
      </v-tab>
    </v-tabs>

    <!-- Content -->
    <v-tabs-items
      id="custom-tab-items"
      :value="selectedTab"
    >
      <v-tab-item
        v-for="i in 2"
        :key="i"
      >
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />
        <div v-if="selectedTab === 0">
          <v-btn
            class="btn-left mt-4"
            color="success"
            raised
            title="Speichern"
            @click="saveWageSupplementTypeConfigurations"
          >
            <i class="fas fa-save mr-3" /> Speichern
          </v-btn>
          <div
            v-for="(
              typeConfiguration, typeIndex
            ) in supplementTypeConfigurations"
            :key="typeIndex"
            class="mt-5 mb-4"
          >
            <wage-supplement-type-configuration-capture
              :wage-supplement-type-configuration="typeConfiguration"
              :wage-supplement-types="wageSupplementTypes"
              @inputContent="updateContent($event, typeIndex)"
            />
          </div>
        </div>
        <div v-if="selectedTab === 1">
          <v-btn
            class="btn-left mt-4"
            color="success"
            raised
            title="Speichern"
            @click="saveWageSupplementTranslations"
          >
            <i class="fas fa-save mr-3" /> Speichern
          </v-btn>
          <div
            v-for="(translation, translationIndex) in supplementTranslations"
            :key="translationIndex"
            class="mt-5 mb-4"
          >
            <wage-supplement-type-configuration-capture
              :wage-supplement-type-configuration="translation"
              :wage-supplement-types="wageSupplementTranslationTypes"
              contents-field="wageSupplementTranslationContents"
              text-field="text"
              type-field="wageSupplementTranslationType"
              @inputContent="updateTranslationContent($event, translationIndex)"
            />
            <hr class="mt-5">
          </div>
        </div>
        <div v-if="selectedTab === 2">
          <wage-supplement-day-of-hour />
        </div>

        <div v-if="selectedTab === 3">
          <wage-supplement-lump-sum-type />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import WageSupplementTypeConfigurationCapture from "@/components/wageSupplement/WageSupplement.TypeConfiguration.Capture.vue";
import WageSupplementLumpSumType from "@/components/wageSupplement/WageSupplement.LumpSum.vue";
import {
  DeleteWageSupplementTypeConfiguration,
  GetWageSupplementTypeConfigurations,
  SaveWageSupplementTypeConfiguration,
} from "@/services/minimum.wage.services/zuschlagsrechner/supplementtypeconfigurations.js";
import { GetWageSupplementTypes } from "@/services/minimum.wage.services/zuschlagsrechner/definition";
import {
  GetWageSupplementTranslationTypes,
  GetWageSupplementTranslations,
  SaveWageSupplementTranslations,
} from "@/services/wageSupplement.translation.service.js";

import wageSupplementDayOfHour from "@/components/wageSupplement/WageSupplement.DayOfHour.vue";

export default {
  components: {
    WageSupplementTypeConfigurationCapture,
    WageSupplementLumpSumType,
    wageSupplementDayOfHour,
  },

  data() {
    return {
      originalSupplementTypeConfigurations: [],
      supplementTypeConfigurations: [],
      originalSupplementTranslations: [],
      supplementTranslations: [],
      wageSupplementTypes: [],
      wageSupplementTranslationTypes: [],
      errorObject: null,
      tabHeaders: [
        "Zuschlagstypen",
        "Zuschlagsrechnertexte",
        "Zeittypen",
        "Zuschlagstyp Pauschalen",
      ],
      selectedTab: 0,
    };
  },
  created() {
    this.loadWageSupplementTypes();
    this.loadWageSupplementTypeConfigurations();
  },
  methods: {
    updateContent(value, index) {
      this.supplementTypeConfigurations[
        index
      ].wageSupplementTypeConfigurationContents = value;
    },
    updateTranslationContent(value, index) {
      this.supplementTranslations[index].wageSupplementTranslationContents =
        value;
    },

    loadWageSupplementTypes() {
      GetWageSupplementTypes(
        (response) => {
          Object.keys(response).forEach((key) => {
            this.wageSupplementTypes.push({
              id: Number(key),
              text: response[key],
            });
          });
        },
        (error) => {
          console.error(error);
          this.isLoading = false;
        },
      );

      GetWageSupplementTranslationTypes(
        (response) => {
          if (response && Object.keys(response).length > 0) {
            let types = [];
            Object.keys(response).forEach((element) => {
              types.push({
                id: element,
                text: response[element],
              });
            });
            this.wageSupplementTranslationTypes = types;
          }
        },
        (error) => {
          console.error(error);
          this.isLoading = false;
        },
      );
    },
    loadWageSupplementTypeConfigurations() {
      GetWageSupplementTypeConfigurations(
        (response) => {
          this.supplementTypeConfigurations = response;
          this.setOriginalSupplementTypeConfigurations();
        },
        (error) => {
          this.errorObject = error;
          console.error(error);
        },
      );

      GetWageSupplementTranslations(
        (response) => {
          this.supplementTranslations = response;
          this.setOriginalSupplementTranslations();
        },
        (error) => {
          this.errorObject = error;
          console.error(error);
        },
      );
    },
    setOriginalSupplementTranslations() {
      this.originalSupplementTranslations = JSON.parse(
        JSON.stringify(this.supplementTranslations),
      );
    },
    setOriginalSupplementTypeConfigurations() {
      this.originalSupplementTypeConfigurations = JSON.parse(
        JSON.stringify(this.supplementTypeConfigurations),
      );
    },
    saveWageSupplementTypeConfigurations() {
      let configurationToSave = this.supplementTypeConfigurations;

      SaveWageSupplementTypeConfiguration(
        configurationToSave,
        () => {
          this.loadWageSupplementTypes();
        },
        (error) => {
          this.errorObject = error;
          console.error(error);
        },
      );
    },
    saveWageSupplementTranslations() {
      let configurationToSave = this.supplementTranslations;
      SaveWageSupplementTranslations(
        configurationToSave,
        () => {
          this.loadWageSupplementTypes();
        },
        (error) => {
          this.errorObject = error;
          console.error(error);
        },
      );
    },
    cancel(typeConfigurationIndex) {
      let cancelledConfiguration =
        this.supplementTypeConfigurations[typeConfigurationIndex];
      if (cancelledConfiguration.id === 0) {
        this.supplementTypeConfigurations =
          this.supplementTypeConfigurations.filter(
            (x) => x.id !== cancelledConfiguration.id,
          );
      }
      let configurationToRestore =
        this.originalSupplementTypeConfigurations.find(
          (x) => x.id === cancelledConfiguration.id,
        );
      if (configurationToRestore) {
        let supplementConfigCopys = JSON.parse(
          JSON.stringify(this.supplementTypeConfigurations),
        );
        supplementConfigCopys[typeConfigurationIndex] = configurationToRestore;
        this.supplementTypeConfigurations = supplementConfigCopys;
      }

      this.editedIds = this.editedIds.filter(
        (x) => x !== cancelledConfiguration.id,
      );
    },
    deleteConfiguration(typeConfigurationIndex) {
      let configurationToDelete =
        this.supplementTypeConfigurations[typeConfigurationIndex];
      if (configurationToDelete.id === 0) {
        this.cancel(typeConfigurationIndex);
        return;
      }

      DeleteWageSupplementTypeConfiguration(
        configurationToDelete.id,
        () => {
          this.editedIds = this.editedIds.filter(
            (x) => x !== configurationToDelete.id,
          );
          this.supplementTypeConfigurations =
            this.supplementTypeConfigurations.filter(
              (x) => x.id !== configurationToDelete.id,
            );
          this.setOriginalSupplementTypeConfigurations();
        },
        (error) => {
          this.errorObject = error;
          console.error(error);
        },
      );
    },
  },
};
</script>
<style scoped></style>
